import { render, staticRenderFns } from "./task-view-detail.vue?vue&type=template&id=8d39346c&"
import script from "./task-view-detail.vue?vue&type=script&lang=js&"
export * from "./task-view-detail.vue?vue&type=script&lang=js&"
import style0 from "./task-view-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports